import { render } from "./Faq.vue?vue&type=template&id=beb4040c&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=beb4040c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb4040c"],['__file',"src/js/components/Faq.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "beb4040c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('beb4040c', __exports__)) {
    api.reload('beb4040c', __exports__)
  }
  
  module.hot.accept("./Faq.vue?vue&type=template&id=beb4040c&scoped=true", () => {
    api.rerender('beb4040c', render)
  })

}


export default __exports__